import {useEffect, useMemo, useRef} from "react";
import L from "leaflet";
import {useMap} from "react-leaflet";

const DEFAULT_PADDING = [30, 30];

const FitBoundsToCoordinates = ({coordinates = [], padding = DEFAULT_PADDING, maxZoom = 16, animate = false}) => {
    const map = useMap();
    const lastSignatureRef = useRef("");

    const points = useMemo(() => {
        return coordinates
            .map((c) => {
                if (Array.isArray(c)) return [Number(c[0]), Number(c[1])];
                if (c && typeof c === "object") {
                    return [Number(c.lat ?? c.latitude), Number(c.lng ?? c.longitude)];
                }
                return [NaN, NaN];
            })
            .filter(([lat, lng]) => Number.isFinite(lat) && Number.isFinite(lng));
    }, [coordinates]);

    const signature = useMemo(() => points.map(([lat, lng]) => `${lat.toFixed(6)},${lng.toFixed(6)}`).join("|"), [points]);

    useEffect(() => {
        if (!points.length) return;
        if (signature === lastSignatureRef.current) return; // evita refit por rerenders/zoom/resize

        lastSignatureRef.current = signature;
        const bounds = L.latLngBounds(points);
        map.fitBounds(bounds, {padding, maxZoom, animate});
    }, [map, points, signature, padding, maxZoom, animate]);

    return null;
};

export default FitBoundsToCoordinates;
